import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`Thanks for visiting my page! Allow me to introduce myself: `}</p>
    <p>{`I’m a Software Engineering graduate and mobile development aficionado. I’ve worked on projects where I built the backend, frontend and everything in between from scratch. I have also spent considerable time as an undergraduate honing my problem solving skills working on lower level languages. I love my work because I get to create something out of nothing. Please let me know if I can add value to your company or brand. I’d love to discuss my projects, previous work and educational training in greater detail so you can make sure I’m capable of delivering the high standards of quality you expect.
Cheers :)`}</p>
    <h6>{`Find more of my works on my `}<a parentName="h6" {...{
        "href": "https://github.com/kevinheych"
      }}>{`Github`}</a>{`.`}</h6>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      